import { render, staticRenderFns } from "./PublicationsList.vue?vue&type=template&id=a15a30aa&scoped=true&"
import script from "./PublicationsList.vue?vue&type=script&lang=js&"
export * from "./PublicationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15a30aa",
  null
  
)

export default component.exports